/** Opt-in by URL only; sticks for this browser so the flow survives login, new tabs and the Shopify install round trip. */
const OSMANTHUS_PARAM = "osmanthus";
const OSMANTHUS_STORAGE_KEY = "replo.osmanthus";

/** `?osmanthus` (or `=true`/`=1`) turns it on, `=false`/`=0` turns it off; null when the URL says nothing. */
function getOsmanthusFromUrl(): boolean | null {
  const value = new URLSearchParams(window.location.search).get(
    OSMANTHUS_PARAM,
  );
  if (value === null) {
    return null;
  }
  return value !== "false" && value !== "0";
}

/** Call once at app start so a `?osmanthus` landing (e.g. on signup) is remembered in this browser, and `?osmanthus=false` forgets it. */
export function rememberOsmanthusFromUrl() {
  if (typeof window === "undefined") {
    return;
  }
  const fromUrl = getOsmanthusFromUrl();
  if (fromUrl === null) {
    return;
  }
  try {
    if (fromUrl) {
      window.localStorage.setItem(OSMANTHUS_STORAGE_KEY, "1");
    } else {
      window.localStorage.removeItem(OSMANTHUS_STORAGE_KEY);
    }
  } catch {
    // Storage blocked: the param still works on the page that carries it.
  }
}

export function isOsmanthusEnabled(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  const fromUrl = getOsmanthusFromUrl();
  if (fromUrl !== null) {
    return fromUrl;
  }
  try {
    return window.localStorage.getItem(OSMANTHUS_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}
